import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "btns"
};
const _hoisted_2 = {
  key: 1
};
import { EditForm } from '@/component-create/EditForm';
import { EventName } from '@/component-create/FormDialog';
import { createIconNode } from '@/component-create/utils/common';

import { ref, toRefs, nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XFormDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    footers: {
      type: Array
    },
    form: {
      type: Object,
      required: true
    },
    width: {
      type: String,
      default: '40%'
    },
    getInstance: Function,
    handler: Object
  },
  emits: ['saveSuccess', 'saveFail', 'loadSuccess', 'loadFail', 'opend'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const confireLoading = ref(false);
    const prop = __props;
    const emit = __emit;
    const editFormRef = ref();
    let form = null;
    const {
      title,
      footers,
      getInstance
    } = toRefs(prop);
    const visible = ref(false);
    const instance = new Proxy({}, {});
    const defaultValue = ref({});
    const customSaveParams = ref({});
    const loading = ref(false);
    /**
     * 暴露属性方法
     */
    if (getInstance?.value) {
      getInstance.value(instance);
    }
    instance.open = open;
    instance.close = close;
    instance.showLoading = showLoading;
    instance.closeLoading = closeLoading;
    instance.setSaveParams = data => {
      customSaveParams.value = data;
    };
    /**
     * 打开对话框
     * @param data
     */
    function open(data) {
      confireLoading.value = false;
      return new Promise(resolve => {
        visible.value = true;
        if (!form) {
          nextTick(() => {
            renderEditForm(data);
            opened();
            resolve(true);
          });
        } else {
          form?.setFormData({});
          setFormValue(data);
          opened();
          resolve(true);
        }
      });
    }
    function opened() {
      if (prop.handler && prop.handler['opend']) {
        prop.handler['opend']();
      } else {
        emit('opend');
      }
    }
    function showLoading() {
      loading.value = true;
    }
    function closeLoading() {
      loading.value = false;
    }
    /**
     * 关闭对话框
     */
    function close() {
      form?.setFormData(defaultValue.value || {});
      form?.elFormInstance?.clearValidate();
      visible.value = false;
      confireLoading.value = false;
    }
    /**
     * 取消
     */
    function cancle() {
      close();
    }
    /**
     * 确认
     */
    function save() {
      if (confireLoading.value) {
        return;
      }
      confireLoading.value = true;
      const customSave = prop.handler && prop.handler['customSave'];
      if (customSave) {
        form?.getFormData().then(res => {
          customSave(res);
          confireLoading.value = false;
        });
      } else {
        form?.save(() => {
          close();
          saveSuccessEvent();
          confireLoading.value = false;
        }, () => {
          saveFailEvent();
          confireLoading.value = false;
        }, () => {
          confireLoading.value = false;
        });
      }
    }
    function customButtonClick(e) {
      form?.getFormData().then(res => {
        e?.(res);
      });
    }
    /**
     * 保存成功事件
     */
    function saveSuccessEvent() {
      if (prop.handler && prop.handler[EventName.SAVE_SUCCESS]) {
        prop.handler[EventName.SAVE_SUCCESS](form?.getFormDataNotValidate());
      } else {
        emit('saveSuccess', form?.getFormDataNotValidate());
      }
    }
    /**
     * 保存失败事件
     */
    function saveFailEvent() {
      if (prop.handler && prop.handler[EventName.SAVE_FAIL]) {
        prop.handler[EventName.SAVE_FAIL]();
      } else {
        emit('saveFail');
      }
    }
    /**
     * 加载成功事件
     */
    function loadSuccessEvent(data) {
      if (prop.handler && prop.handler[EventName.LOAD_SUCCESS]) {
        prop.handler[EventName.LOAD_SUCCESS](data);
      } else {
        emit('loadSuccess', data);
      }
    }
    /**
     * 加载失败事件
     */
    function loadFailEvent() {
      if (prop.handler && prop.handler[EventName.LOAD_FAIL]) {
        prop.handler[EventName.LOAD_FAIL]();
      } else {
        emit('loadFail');
      }
    }
    /**
     * 创建按钮
     * @param el VNode绘制函数
     */
    function createButton(el) {
      return el(form);
    }
    function renderEditForm(data) {
      form = new EditForm(editFormRef.value, prop.form.items, {
        labelPosition: 'right',
        labelWidth: '80px',
        ...prop.form.elFormProps
      }, prop.form.saveUrl, prop.form.loadUrl, prop.form.loaded, prop.form.saveMethods);
      instance.getFormDataNotValidate = form.getFormDataNotValidate.bind(form);
      instance.setFormData = form.setFormData.bind(form);
      instance.getFormData = form.getFormData.bind(form);
      instance.save = form.save.bind(form);
      instance.updateFormData = form.updateFormData.bind(form);
      instance.hideFormItemByKey = form.hideFormItemByKey.bind(form);
      instance.showFormItemByKey = form.showFormItemByKey.bind(form);
      instance.setSaveParams = form.setSaveParams.bind(form);
      form.setSaveParams(customSaveParams.value);
      Reflect.ownKeys(form.getFormDataNotValidate()).forEach(key => {
        defaultValue.value[key] = form?.getFormDataNotValidate()[key];
      });
      setFormValue(data);
    }
    function setFormValue(data) {
      if (data && prop.form.loadUrl) {
        form?.load(data).then(data => {
          loadSuccessEvent(data);
        }).catch(() => {
          loadFailEvent();
        });
      } else if (data) {
        form?.updateFormData(data);
      }
    }
    function getFormInstance() {
      return form;
    }
    __expose({
      open,
      close,
      getFormInstance,
      showLoading,
      closeLoading
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(visible) ? visible.value = $event : null),
        title: _unref(title),
        width: __props.width,
        onClose: close
      }, {
        footer: _withCtx(() => [_unref(footers) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footers), (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["item", {
              'first': index === 0
            }])
          }, [item.el ? (_openBlock(), _createBlock(_resolveDynamicComponent(createButton(item.el)), {
            key: 0
          })) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: item.type,
            icon: _unref(createIconNode)(item.icon),
            onClick: $event => customButtonClick(item.handler)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.text), 1)]),
            _: 2
          }, 1032, ["type", "icon", "onClick"]))], 2);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: cancle
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save,
          loading: _unref(confireLoading)
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("确认")])),
          _: 1
        }, 8, ["loading"])]))]),
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
          ref_key: "editFormRef",
          ref: editFormRef
        }, null, 512), [[_directive_loading, _unref(loading)]])]),
        _: 1
      }, 8, ["modelValue", "title", "width"]);
    };
  }
});